import React, { Component } from 'react';
import { connect } from 'react-redux';
import Util from '../../util.js';
import { hashHistory } from 'react-router';
import NavigatorMain from '../NavigatorMain';
/*智投交易记录*/
class TransitHistory extends Component {
  goBack() {
    hashHistory.goBack();
  }
  componentDidMount(){
    document.title = '历史调仓记录'
  }
  push(item){
    hashHistory.push({
      pathname:'/TransitHistoryDetial',
      state:{data:item}
    })
  }
  render() {
    let data=Util.deepClone(this.props.location.state.data)
    console.log(this.props.location.state.data);

    return (
        <div className="container">
          <NavigatorMain>
            <div className="header black">
              <div onClick={()=>this.goBack()}><span className="headerLeftBtn"></span></div>
              <div>历史调仓记录</div>
              <div></div>  
            </div>
          </NavigatorMain>
          <div className='content TransitHistory-content'>
          { 
            data.reverse().map( (item,i) =>{
              return(
                <div className='TransitHistory-item'  key={'TH'+i} onClick={() => this.push(item)} >
                  <div>
                    <div>{`${Util.returnDate(item.adjustDate)}调仓记录`}</div>
                    <div>根据最近的市场情况，查理对组合进行了资产配置调整：</div>
                  </div>
                  <img src={require('../../img/rightArrow.png')} style={{marginRight:'0px'}} className='img'/>
                </div>
              )
            })
          }
          </div>
        </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    
  }
}

export default connect(mapStateToProps)(TransitHistory);





// WEBPACK FOOTER //
// ./src/components/fundDetail/TransitHistory.js